import React, { useCallback, useContext } from 'react';
import { TranslatorContext } from '@jutro/locale';
import { SgDateUtil } from 'saga-modules';
import { useHistory } from 'react-router-dom';
import { Button } from '@jutro/components';
import SgCepLobSpecificUtil from 'sg-cep-lob-specific-util';
import messages from './SgPolicySummaryTile.messages';

function SgPolicyTile(props) {
    const {
        id,
        policy
    } = props;

    const history = useHistory();
    const translator = useContext(TranslatorContext);

    const navigateTo = useCallback((path, state) => {
        history.push(path, state);
    }, [history]);

    return (
        <div id={`policySummary_${id}`} className="sg-policy-summary sg-policy-tile">
            <div id={`infoContainer_${id}`} className={`sg-policy-tile-details-container ${policy.productCode}`}>
                <h3 id={`header_${id}`} className="sg-policy-description">
                    {policy.policyHeader.header}
                    <span className="sg-policy-registration-number">
                        {policy.policyHeader.subHeader && (
                            <>
                                <span className="separator" />
                                {policy.policyHeader.subHeader}
                            </>
                        )}
                        {policy.policyHeader.currentOrRenewed
                            ? <span className="separator" /> : ''}
                        {policy.policyHeader.currentOrRenewed}
                    </span>
                </h3>
                <div className="sg-policy-info">
                    <h3>{translator(messages.PolicyNumber)}</h3>
                    <h3 id={`policy_${id}`}>{policy.periods[0].policyId}</h3>
                </div>
                <div className="sg-clear-both" />
                <div className="sg-policy-info sg-policy-info-ver-level sg-hide-for-phone-portrait-down">
                    <h3>{translator(SgCepLobSpecificUtil.getPolicySummaryCoverLabel(policy.productCode))}</h3>
                    <h3 id={`coverLevel_${id}`}>{policy.coverLevel}</h3>
                </div>
                <div className="sg-clear-both" />
                <div className="sg-policy-info">
                    <h3>{translator(messages.StartDate)}</h3>
                    <h3 id={`policySummary_${id}`}>
                        {SgDateUtil.getDateWithFullMonthName(policy.periods[0].effective)}
                    </h3>
                </div>
                <div className="sg-clear-both" />
                {SgCepLobSpecificUtil.getLobSpecificPolicyInfo(id, policy, translator)}
            </div>
            <div id={`buttonContainer_${id}`} className="sg-policy-tile-button-container">
                <Button id={`document_${id}`} className="sgButton sgPrimaryButton" onClick={() => navigateTo('/documents')}>
                    {translator(messages.MyDocuments)}
                </Button>
                <br className="sg-hide-for-phone-landscape-up" />
                <Button
                    id={`changePolicy_${id}`}
                    className="sgButton sgPrimaryButton"
                    onClick={() => navigateTo('/endorsement',
                        {
                            policyNumber: policy.periods[0].policyId,
                            isScheduled: policy.isScheduled
                        })}
                >
                    {translator(messages.AmendPolicy)}
                </Button>
                <br className="sg-hide-for-phone-landscape-up" />
                <Button
                    id={`payment_${id}`}
                    className="sgButton sgPrimaryButton"
                    onClick={() => navigateTo(`billing-summary/${policy.periods[0].policyId}`)}
                >
                    {translator(messages.Payments)}
                </Button>
            </div>
            <div className="sg-clear-both" />
        </div>
    );
}

export default SgPolicyTile;
